import Image from 'next/image'
import React from 'react'

import AppStoreImage from '~/assets/icons/app-store.png'
import GooglePlayImage from '~/assets/icons/google-play.png'

const AppLinksBox: React.FC = () => {
  return (
    <div className="fixed right-5 bottom-5 z-[9999] bg-opacity-100 bg-neutral-white p-2 rounded-md shadow-lg flex flex-col items-center w-[90%] max-w-[260px]">
      <h2 className="text-2xl font-bold text-black mb-2">
        BAIXE AGORA GETBRAZA
      </h2>
      <div className="flex justify-between w-full">
        {/* Link para Google Play */}
        <a
          href="https://play.google.com/store/apps/details?id=uk.braza.getbraza"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:opacity-80"
        >
          <Image
            src={GooglePlayImage}
            alt="Google Play"
            width={120}
            height={90}
          />
        </a>
        {/* Link para App Store */}
        <a
          href="https://apps.apple.com/us/app/getbraza/id6482982729"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:opacity-80"
        >
          <Image src={AppStoreImage} alt="App Store" width={120} height={90} />
        </a>
      </div>
    </div>
  )
}

export default AppLinksBox
